import { render, staticRenderFns } from "./AirportList.vue?vue&type=template&id=2f30de1e&scoped=true&"
import script from "./AirportList.vue?vue&type=script&lang=js&"
export * from "./AirportList.vue?vue&type=script&lang=js&"
import style0 from "./AirportList.vue?vue&type=style&index=0&id=2f30de1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f30de1e",
  null
  
)

export default component.exports